import { types as t, getParent } from 'mobx-state-tree';
//import Variant from './Variant';
import ProductMedia from './ProductMedia';
import VariantGroup from './VariantGroup';

import NewVariantGroup from './NewVariantGroup';
import Stock from './Stock';
import PropertyItem from './PropertyItem';
import Ad from './Ad';



const Product = t.model("Product", {
    //Guid: t.identifier,
    GroupKey: t.maybeNull(t.string),
    Sku: t.maybeNull(t.string),
    VariantSku: t.maybeNull(t.string),
    Guid: t.maybeNull(t.string),
    ComingSoon: t.optional(t.boolean, false),
    AllowOrdering: t.optional(t.boolean, false),
    ProductDefinition: t.maybeNull(t.string),
    PrimaryImageUrl: t.maybeNull(t.string),
    ProductId: t.maybeNull(t.string),
    //ThumbnailImageUrl: t.string,
    DisplayName: t.maybeNull(t.string),
    UrlName: t.maybeNull(t.string),
    UrlSlug: t.maybeNull(t.string),
    ShortDescription: t.maybeNull(t.string),
    LongDescription: t.maybeNull(t.string),
    Name: t.maybeNull(t.string),
    ProductType: t.maybeNull(t.number),
    Variants: t.maybeNull(t.optional(t.array(t.late(() => Product)), [])),
    Preload: t.maybeNull(t.boolean),
    Siblings: t.maybeNull(t.optional(t.array(t.late(() => Product)), [])),
    TypicallyBoughtWith: t.maybeNull(t.optional(t.array(t.late(() => Product)), [])),
    CustomerAlsoBought: t.maybeNull(t.optional(t.array(t.late(() => Product)), [])),
    RelatedProducts: t.maybeNull(t.optional(t.array(t.late(() => Product)), [])),
    SizeInformationId: t.maybeNull(t.string),
    Stock: t.array(Stock),
    InStock: t.optional(t.boolean, false),
    Price: t.maybeNull(t.number),
    PriceEx: t.maybeNull(t.number),
    PriceFormatted: t.maybeNull(t.string),
    PriceExFormatted: t.maybeNull(t.string),
    ListPrice:t.maybeNull(t.number),
    ListPriceEx:t.maybeNull(t.number),
    ListPriceFormatted: t.maybeNull(t.string),
    ListPriceExFormatted: t.maybeNull(t.string),
    RetailPriceFormatted:t.maybeNull(t.string),
    DiscountPercentFormatted: t.maybeNull(t.string),
    Currency: t.maybeNull(t.string),
    CurrencyCode: t.maybeNull(t.string),
    ProductGroup: t.optional(t.array(t.late(() => Product)), []),
    AdditionalImagesUrls: t.maybeNull(t.array(t.string)),
    VariantGroups: t.maybeNull(t.array(VariantGroup)),
    NewVariantGroups: t.optional(t.array(NewVariantGroup), []),

    Properties: t.optional(PropertyItem, {}),
    Technologies: t.optional(PropertyItem, {}),
    Ads: t.maybeNull(t.optional(t.array(Ad), [])),
    GroupByKeys: t.optional(t.array(t.string), []),
    ProductMedia: t.maybeNull(t.array(ProductMedia)),
    Tags: t.optional(t.array(t.string), [])
}).views(self => ({


    get ParentProduct() {
        return getParent(self, 2);
    },

    // get VariantInStock() {
    //     return self.ParentProduct.Stock.filter(x => x.Sku === self.Sku || x.sku === x.VariantSku).reduce((total, item) => total + item.Quantity, 0) > 0;
    // },

    // get InStock() {
    //     return self.Stock.reduce((total, item) => total + item.Quantity, 0) > 0;
    // },
    
    get HasVariants() {
        return self.Variants && self.Variants.length > 0;
    },
    PropertyByKey(key) {
        const p = self.Properties[key];
        if (p) {
            return p;
        } else {
            return null;
        }
    },

    HasTag(tag) {
        return self.Tags && self.Tags.length > 0 && self.Tags.indexOf(tag) > -1;
    },
    
    PropertyByKeyFuzzy(key) {
        let p = this.PropertyByKey(key);
        if (p) {
            return p;
        } else {
            key = Object.keys(self.Properties).find((prop) => {
                return prop.indexOf(key) > -1;
            });
            return this.PropertyByKey(key);
        }
    },


    //get RenderGroups() {
    //    const groups = [];
    //    for (const groupKey of self.GroupByKeys) {

    //        const variantsGroups = groupBy(self.Variants, groupKey, "Variants");
    //        const variantsAndImages = groupBy(self.ProductMedia, groupKey, "Images", variantsGroups);

    //        const group = {
    //            GroupKey: groupKey,
    //            Items: variantsAndImages
    //        }
    //        groups.push(group);
    //    };

    //    console.log("Groups", groups);
    //    return groups;
    //},

    FilteredVariants(filter) {
        // filter: [{GroupKey:"ColorId",GroupValue:"099"},{GroupKey:"Size",GroupValue:"4XL"}]

        return {

            Variants: self.Variants.filter(v => filter.every(f => {
                return !v.Properties[f.GroupKey] || v.Properties[f.GroupKey] === f.GroupValue;
            })),
            Images: self.ProductMedia ? self.ProductMedia.filter(v => filter.every(f => {
                return !v.Properties[f.GroupKey] || v.Properties[f.GroupKey] === f.GroupValue;
            })) : null
        }

        //todo: return: {Variants:[], Images:[]}

    }

    

})).actions(self => ({

}));

function groupBy(array, groupByKey, propertyName, existingArray) {
    const result = array.reduce((r, a) => {
        const groupKey = a.Properties[groupByKey];

        // name available? "ColorId" -> "Color"-- convention
        const groupNameKey = groupByKey.substr(0, groupByKey.length - 2);
        //console.log("groupNameKey", groupKey, groupKey.length , groupNameKey);
        const groupName = a.Properties[groupNameKey] || groupKey;
        //const groupArrayIndex =  "_" + groupKey;

        let groupItem = r.find(x => x.GroupKey === groupKey);
        if (!groupItem) {
            groupItem = { GroupKey: groupKey, GroupName: groupName };
            r.push(groupItem);
        }

        groupItem[propertyName] = groupItem[propertyName] || [];

        groupItem[propertyName].push({ ...a });

        return r;
    }, existingArray || []);
    return result;
}

export default Product;